import { Control, Controller } from 'react-hook-form';

import { SelectInput } from '@/components';
import { SelectInputOption } from '@/components/inputs/SelectInput';

export interface FormSelectInputProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  options: SelectInputOption[];
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  loading?: boolean;
  unknownValueLabel?: string;
}

const FormSelectInput = ({
  name,
  placeholder,
  control,
  options,
  required = false,
  disabled = false,
  autoFocus = false,
  loading = false,
  unknownValueLabel,
}: FormSelectInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <SelectInput
          {...field}
          placeholder={placeholder}
          options={options || []}
          errorInfo={error?.message}
          error={!!error}
          autoFocus={autoFocus}
          required={required}
          disabled={disabled}
          loading={loading}
          {...(unknownValueLabel !== undefined && { unknownValueLabel })}
        />
      )}
    />
  );
};

export default FormSelectInput;
